import { Link, navigate } from 'gatsby';
import PropTypes from 'prop-types';
import React, {useEffect, useState, useRef } from 'react';
import ncsacwLogo from "assets/images/ncsacw-logo.svg";
import { useStrapiTopicData } from '../../../hooks';
import { Button } from "components/ui";
import SearchForm from "components/search-form";
import {navigation} from "@uswds/uswds/src/js/components";
import {Overlay} from "components/global";
import SvgIcon from '../SvgIcon/SvgIcon';

const isBrowser = typeof window !== "undefined"
const Header = ({ location, siteTitle, navigationLinks, children }) => {
  const [display, setDisplay] = useState(false);
  const [navGroupIndex, setNavGroupIndex] = useState(-1);
  const [isOpened, setIsOpened] = useState(false);
  const headerRef = useRef()
  const openMenu =()=>{
    setDisplay(true)
  }
  const closeMenu=()=>{
    setDisplay(false)
    setNavGroupIndex(-1)
    setIsOpened(false)
  }

  // const handleClick=e=>{
  //   e.preventDefault();


  // }
  //const ref = useRef(null);
  // const handleClick=()=>{
  //   navigation.toggleNav(true);
  // }

  const { allStrapiTopic } = useStrapiTopicData();

  useEffect(() => {
    //initialize
    navigation.on();
    // navigation.focusTrap.update(ref);
    // navigation.toggleNav(true);
    //default ref is document.body, if you want to use
    //default you do not have to pass arguments
    //navigation.focusTrap();

    //remove event listeners when the component un-mounts.
    return () => {
      navigation.off();
    };
  });

  // redirect to parent page on double click of the menu
  const handleGroupTitleClick = (navigationGroup) => {
    navigate(navigationGroup.link);
  };

  const onElementFocus = (e) => {
    if (e.key === "Tab" && e.target.tagName.toLowerCase().includes('button') && e.target.classList.contains('usa-accordion__button')) {
      e.target.click();
    }
  }
  const handleNavClick = (e, index, navigationGroupLink) => {
    if (location.pathname === navigationGroupLink) {
      setDisplay(false)
      setNavGroupIndex(-1)
      setIsOpened(false)
      document?.querySelectorAll(".usa-nav__submenu")?.forEach(element=>element.setAttribute("hidden", true))
    } else {
      setIsOpened(true);
      if(isBrowser) {
        document?.querySelectorAll(".usa-nav__submenu")?.forEach(element=>element.setAttribute("hidden", true));
        document.querySelector(`#extended-mega-nav-section-${index}`).setAttribute("hidden", false);
      }
      if (isOpened && index === navGroupIndex) {
        setDisplay(false)
        setNavGroupIndex(-1)
        setIsOpened(false)
        document?.querySelectorAll(".usa-nav__submenu")?.forEach(element=>element.setAttribute("hidden", true))
        navigate(navigationGroupLink);
      }
      setNavGroupIndex(-1);
      setTimeout(() => {
        setNavGroupIndex(index);
      }, 40);
    }

  }
  const onElementBlur = (e) => {
    if (e.target.parentElement.parentElement.parentElement.parentElement.childNodes[0].classList.contains('usa-accordion__button')) {
      setDisplay(false)
      setNavGroupIndex(-1)
      setIsOpened(false)
      document?.querySelectorAll(".usa-nav__submenu")?.forEach(element=>element.setAttribute("hidden", true))
    }
  }
  useEffect(() => { 
    let count = 1;
    document.body.addEventListener('keydown', e => { 
      if (e.key !== 'Tab' ) {
         return 
        } 
      if(display === true) { 
        let focusableElements=`.usa-nav button, .usa-nav a[href], .usa-nav input`;
        let firstFocusableElement=document?.querySelector(`.usa-nav__close`); 
        let lastFocusableElement=document?.querySelector(`.usa-nav`)?.querySelectorAll(focusableElements)[document?.querySelector(`.usa-nav`)?.querySelectorAll(focusableElements).length-1]; 
        if(count === 1) { 
          document?.querySelectorAll(".usa-nav__primary-item a")[0]?.focus() 
          e.preventDefault() 
          count++ 
        } 
        if(document.activeElement === lastFocusableElement) { 
          firstFocusableElement?.focus() 
          e.preventDefault() 
          count = 2 
        } 
      }
    })}, [display])
    const verifyElementIncludedInNav = (nav, element) => {
      let node = element.parentNode;
  
      while (node !== null) {
          if (node === nav.current) {
              return true;
          }
       node = node.parentNode;
       }
     return false;
    }

    useEffect(()=>{
      document.body.addEventListener('keydown', e => { 
        if (e.key === "Escape" ) {
          setDisplay(false)
          setNavGroupIndex(-1)
          setIsOpened(false)
          document?.querySelectorAll(".usa-nav__submenu")?.forEach(element=>element.setAttribute("hidden", true))
        } 
      })
      window.addEventListener("resize", ()=>{
        setDisplay(false)
        setNavGroupIndex(-1)
        setIsOpened(false)
        document?.querySelectorAll(".usa-nav__submenu")?.forEach(element=>element.setAttribute("hidden", true))
      })
      document.addEventListener('mousedown', e => { 
        if (isOpened && (verifyElementIncludedInNav(headerRef, e.target)=== false)) {
          setDisplay(false)
          setNavGroupIndex(-1)
          setIsOpened(false)
          document?.querySelectorAll(".usa-nav__submenu")?.forEach(element=>element.setAttribute("hidden", true))
        } 
        if(isOpened && verifyElementIncludedInNav(headerRef, e.target)){
           navigate(e.target.href)
        }
      })
    }, [isOpened, navGroupIndex, display])

  if (isBrowser) {
    if(location.pathname === "/"){
      document?.querySelector(".usa-nav__inner .usa-current")?.addEventListener("click", ()=>{
        setDisplay(false)
        setNavGroupIndex(-1)
        setIsOpened(false)
        document?.querySelectorAll(".usa-nav__submenu")?.forEach(element=>element.setAttribute("hidden", true))
      })
    }
  }

return <><Overlay isVisible={display} />
<header className="usa-header usa-header--extended">
    <div className="usa-navbar">
      <div className="usa-logo" id="extended-logo">
        <em className="usa-logo__text">
          <Link to="/" title={siteTitle} aria-label={siteTitle}>
            <img className="desktop:width-card-lg tablet:width-card" src={ncsacwLogo} alt="National Center on Substance Abuse and Child Welfare" />
          </Link>
        </em>
      </div>
      <Button btnType="usa-menu-btn" onClick={openMenu} ariaExpanded={display}>
        Menu
      </Button>
    </div>
    <nav aria-label="Primary navigation" role="navigation" className="usa-nav" ref={headerRef}>
      <div className="usa-nav__inner">
        <div className="usa-nav__secondary usa-header--extended margin-bottom-2 nav-desktop">
          <div className="desktop:display-flex">
            <Button color="primary-button" size="width-full margin-right-2" link="mailto:ncsacw@cffutures.org">Request Assistance</Button>
            <SearchForm idName="extended-search-field-small"/>
          </div>
        </div>
        <Button
        btnType="usa-nav__close"
        onClick={closeMenu}
        labelText="Close the menu"
        >
          <SvgIcon name="close"/>
        </Button>
        <ul className="usa-nav__primary usa-accordion">
          {navigationLinks.map((navGroup, idx) => (
          <li key={`header-nav-group-${idx}`} className="usa-nav__primary-item" onKeyUp={onElementFocus}  aria-label={navGroup.title}>
            {navGroup.items.length > 1 ? (
             <>
                <button
                  type="button"
                  className={`usa-accordion__button usa-nav__link ${
                    location.pathname.includes(navGroup.link) ? 'usa-current' : ''
                  }`}
                  aria-controls={`extended-mega-nav-section-${idx}`}
                  aria-expanded={isOpened && idx === navGroupIndex}
                  onClick={(e) => handleNavClick(e, idx, navGroup.link)}
                  >
                    <span onDoubleClick={e => {
                         e.preventDefault();
                         if(window?.location?.pathname.includes(navGroup.link)){
                           window.location.reload();
                          }
                        if(!window?.location?.pathname.includes(navGroup.link)){
                          handleGroupTitleClick(navGroup);
                        }
                      }}
                    >
                      {navGroup.title}
                    </span>
                  {/* <Link to={navGroup.link}><span>{navGroup.title}</span></Link> */}
                </button>
                {
                  navGroup.title.toLowerCase().indexOf("topics") > 0 ?
                (allStrapiTopic &&
                  <div id={`extended-mega-nav-section-${idx}`} className="usa-nav__submenu usa-megamenu" hidden>
                    <ul className="usa-nav__submenu-list grid-row">
                      {allStrapiTopic?.nodes.map((topic, idx) => (
                        <li key = {`header-nav-link-${idx}`} className="usa-nav__submenu-item desktop:grid-col-4" onFocus={onElementFocus} aria-label={topic?.card_title ?? topic?.title}>
                          <Link to={`/topics/${topic.slug}`} aria-label={topic?.card_title ?? topic?.title}>
                            <span>
                              {topic?.card_title ?? topic?.title}
                            </span>
                          </Link>
                        </li>
                     ))}
                    </ul>
                  </div>
                )
                :
                <div id={`extended-mega-nav-section-${idx}`} className="usa-nav__submenu usa-megamenu" hidden>
                    <ul className="usa-nav__submenu-list grid-row">
                     {navGroup.items.map((navItem, navItemIdx) => (
                      <li  onKeyDown={(e) => {
                        if (navItemIdx === navGroup.items.length-1 && idx === navigationLinks.length-2) {
                          onElementBlur(e);
                        }
                      }} key = {`header-nav-link-${navItemIdx}`} className="usa-nav__submenu-item desktop:grid-col-4" aria-label={navItem.text}>
                        <Link to={navItem.link} aria-label={navItem.text}>
                          <span>
                            {navItem.text}
                          </span>
                        </Link>
                      </li>
                         ))}
                    </ul>
                </div>
                }
                </>
              ) : (
                      <Link
                        className="usa-nav__link"
                        activeClassName="usa-current"
                        to={navGroup.items[0].link}
                        aria-label={navGroup.items[0].text}
                      >
                        <span>{navGroup.items[0].text}</span>
                      </Link>
                    )}
                  </li>
              ))}
          </ul>
      <div className="usa-nav__secondary usa-header--extended margin-bottom-2 nav-mobile">
        <div className="desktop:display-flex">
          <Button color="primary-button" size="width-full margin-right-2" link="mailto:ncsacw@cffutures.org">Request Assistance</Button>
          <SearchForm idName="extended-search-field-small-mobile" />
        </div>
      </div>
        </div>
      </nav>
      { children }
  </header>
  </>
};
export default Header;

Header.propTypes = {
  siteTitle: PropTypes.string,
  navigationLinks: PropTypes.array
};

Header.defaultProps = {
  siteTitle: ``,
};
